import { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { identifyUser, resetUser } from "lib/mixpanel";
const AuthContext = createContext();

const API_HOST = process.env.REACT_APP_BASE_URL;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);
  const [token, setToken] = useLocalStorage("auth", null);
  const navigate = useNavigate();

  const login = async (token) => {
    if (!token || typeof token !== "string") {
      console.error("❌ Invalid token provided to login");
      console.error("Token type:", typeof token);
      console.error("Token value:", token);
      return;
    }

    const user = jwtDecode(token);
    setToken(token);
    setUser(user);

    // Identify admin in Mixpanel
    identifyUser({
      id: user.id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
      role: user.role,
      organizationId: user.organizationId || user.churchId,
      orgName: user.organizationName || user.churchName,
      campusId: user.campus,
      status: user.status,
      createdAt: user.createdAt,
    });

    // Extract and store church slug from subdomain
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    if (parts.length >= 2) {
      const subdomain = parts[0];
      localStorage.setItem("churchSlug", subdomain);
    }

    navigate("/admin/dashboard");
  };

  // call this function to sign out logged in user
  const logout = () => {
    resetUser();
    localStorage.removeItem("auth");
    localStorage.removeItem("user");
    localStorage.removeItem("churchSlug");
    localStorage.removeItem("atriumChurchSlug");

    window.location.href = "/auth/signin";
  };

  return (
    <AuthContext.Provider value={{ user, token, login, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
